import { WhatsNewPage } from './WhatsNewPage';
import { chapters, type ServiceInfoChapter } from '../chapters';
import { IntroductionPage } from './IntroductionPage';
import { FeedbackPage } from './FeedbackPage';

type PagesProps = {
    page: ServiceInfoChapter;
};

export const Pages = ({ page = chapters.whatsNew }: PagesProps) => {
    switch (page) {
        case chapters.welcome:
            return <IntroductionPage />;
        case chapters.whatsNew:
            return <WhatsNewPage />;
        case chapters.feedback:
            return <FeedbackPage />;
        default:
            return <IntroductionPage />;
    }
};
